import React from "react";
import { HashLink as Link } from "react-router-hash-link";

class FooterComponent extends React.Component {
  render() {
    return (
      <footer id="footer" className="footer-light">
        <div className="footer-content p-b-0 p-t-30">
          <div className="container">
            <div className="row text-left">
              <div className="col-md-4">
                {/* Footer widget area 1 */}
                <div
                  className="widget clearfix widget-contact-us"
                  style={{
                    backgroundImage: 'url("images/world-map-dark.png")',
                    backgroundPosition: "50% 20px",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <h4>NUTECH CANCER BIOMARKERS<br></br>(A US Based Subsidiary)</h4>
                  <ul className="list-icon">
                    <li>
                      <i className="fa fa-map-marker" />Office#4, Green Meadows
                      5F,
                      <br /> Lokhandwala Township,
                      <br /> Kandivali (E), Mumbai-400101
                    </li>
                    <li>
                      <i className="fa fa-phone" /> +91 88986-64466
                    </li>
                    <li>
                      <i className="fa fa-fax" />
                      +91-22-2966 3990
                    </li>
                    <li>
                      <i className="fa fa-envelope" />{" "}
                      <a href="mailto:admin@nutechbiomarkersindia.com" style={{color:"#11239f"}}>
                        admin@nutechbiomarkersindia.com
                      </a>
                    </li>
                    {/*  <li>
                      <br />
                      <i className="fa fa-clock-o" />
                      Monday - Friday: <strong>09:00 - 17:00</strong>
                      <br />
                      Saturday - Sunday: <strong>Closed</strong>
                  </li>*/}
                  </ul>
                  {/* Social icons */}
                  <div className="social-icons social-icons-border float-left m-t-20">
                    <ul>
                      <li className="social-facebook">
                        <a
                          href="https://www.facebook.com/nutechbiomarkers/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li className="social-youtube">
                        <a
                          href="https://www.youtube.com/user/kelavkar"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-youtube" />
                        </a>
                      </li>
                      <li className="social-linkedin">
                        <a
                          href="https://www.linkedin.com/company/nutech-cancer-biomarkers-india-private-limited/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-linkedin" />
                        </a>
                      </li>
 <li className="social-instagram">
                        <a
                          href="https://www.instagram.com/p/CGm7FPqHPSW/?igshid=1ukptdl20he97"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-instagram" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* end: Social icons */}
                </div>
                {/* end: Footer widget area 1 */}
              </div>
              <div className="col-md-2">
                {/* Footer widget area 2 */}
                <div className="widget">
                  <h4>Our Company</h4>
                  <ul className="list-icon list-icon-arrow">
                    <li>
                      <a href="/company/about">About Us</a>
                    </li>
                    <li>
                      <a href="/company/mission">Mission</a>
                    </li>

                  

                    <li>
                      <a href="/company/team">Our Team
</a>
                    </li>
                   
                  </ul>
                </div>
                {/* end: Footer widget area 2 */}
              </div>
              <div className="col-md-3 footerpaddingleft">
                {/* Footer widget area 3 */}
                <div className="widget">
                  <h4> Caregivers</h4>
                  <ul className="list-icon list-icon-arrow">
                    <li>
                      <a href="/caregivers/seromarktest-1">SeroMark-1 Test</a>
                    </li>
                    <li>
                      <a href="/caregivers/psa-test">PSA Test</a>
                    </li>
                    <li>
                      <a href="/caregivers/limitations-of-pas-test">Limitations of PSA Test</a>
                    </li>
  <li>
                      <a href="/caregivers/difference-between-screening-and-diagnostic-tests">Difference between Screening and Diagnostic Tests</a>
                    </li>
  <li>
                      <a href="/downloads/clinic-broucher.pdf"  target="_blank"
>Clinician's Brochure</a>
                    </li>

                    <li>
                      <a href="/caregivers/faqs">FAQs by Caregivers</a>
                    </li>
                  </ul>
                </div>
                {/* end: Footer widget area 3 */}
              </div>
              <div className="col-md-3">
                {/* Footer widget area 4 */}
                <div className="widget">
                  <h4>Patients</h4>
                  <ul className="list-icon list-icon-arrow">
                    <li>
                      <a href="/patients/about-the-prostate">About the Prostate</a>
                    </li>
                    <li>
                      <a href="/patients/symptoms">Symptoms</a>
                    </li>
                    <li>
                      <a href="/patients/prostate-cancer">
                         Prostate Cancer
                      </a>
                    </li>
                    <li>
                      <a href="/patients/screening-tests">Screening Tests</a>
                    </li>
                     <li>
                      <a href="/downloads/patient-broucher.pdf"   target="_blank"
>Patient's Brochure
</a>
                    </li>


 <li>
                      <a href="/downloads/ask-your-doctor_r3.pdf"  target="_blank"
>Ask Your Doctor
</a>
                    </li>


 <li>
                      <a href="/patients/faqs">FAQs by Patients
</a>
                    </li>

                  </ul>
                </div>
                {/* end: Footer widget area 4 */}
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-content p-b-20 p-t-20">
          <div className="container">
            <div className="col-md-9">
              <div className="copyright-text">
                <i className="fa fa-copyright"></i> {new Date().getFullYear()}
                &nbsp;NUTECH CANCER BIOMARKERS INDIA PRIVATE LIMITED.
              </div>
            </div>
            <div className="col-md-3">
              {" "}
              <img src="/images/payment.png" className="payment"></img>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default FooterComponent;
